import { useTranslation } from 'react-i18next';
import Section from "./Section";

const CGU = () => {
  const { t } = useTranslation();

  return(
    <Section title={t('legal.cgu.title')} subtitle={t('legal.cgu.subtitle')}>
      <h2>{t('legal.cgu.generalConditions.title')}</h2>
      <p>
        {t('legal.cgu.generalConditions.p1')}
      </p>
      <p>
        {t('legal.cgu.generalConditions.p2')}
      </p>
      <p>
        {t('legal.cgu.generalConditions.p3')}
      </p>
      <h2>{t('legal.cgu.intellectualProperty.title')}</h2>
      <p>
        {t('legal.cgu.intellectualProperty.content')}
      </p>
      <h2>{t('legal.cgu.ageRestrictions.title')}</h2>
      <p>
        {t('legal.cgu.ageRestrictions.content')}
      </p>
      <h2>{t('legal.cgu.accounts.title')}</h2>
      <p>
        {t('legal.cgu.accounts.intro')}
      <ol>
        <li>
          {t('legal.cgu.accounts.item1')}
        </li>
        <li>
          {t('legal.cgu.accounts.item2')}
        </li>
      </ol>
      </p>
      <p>
        {t('legal.cgu.accounts.disclaimer')}
      </p>
      <h2>{t('legal.cgu.liability.title')}</h2>
      <p>
        {t('legal.cgu.liability.content')}
      </p>
      <h2>{t('legal.cgu.applicableLaws.title')}</h2>
      <p>
        {t('legal.cgu.applicableLaws.content')}
      </p>
      <h2>{t('legal.cgu.severability.title')}</h2>
      <p>
        {t('legal.cgu.severability.content')}
      </p>
      <h2>{t('legal.cgu.modifications.title')}</h2>
      <p>
        {t('legal.cgu.modifications.content')}
      </p>
      <h2>{t('legal.cgu.contact.title')}</h2>
      <p>
        {t('legal.cgu.contact.content')}
      </p>
      <p>{t('legal.cgu.effectiveDate')}</p>
    </Section>
  )}
export default CGU
